/**
 * @file Document Editor component for Airlift integration
 * @version 1.0.0
 * @since 2025-09-03
 */

import ObjectEditor from '../../json-editor/ObjectEditor.js';
import { useDb } from '../../core/db.js';
import { useDocument } from '../composables/document.js';
import { getCollection } from '../composables/collection.js';

export default {
  name: 'DocumentEditor',

  setup(props) {
    const colRef = Vue.computed(() =>
      typeof props.collection === 'string'
        ? getCollection(props.collection)
        : props.collection
    );
    const doc = Vue.computed(() => useDocument(colRef.value, props.document));

    return { db: useDb(), doc };
  },

  components: {
    'object-editor': ObjectEditor,
  },

  props: {
    collection: {
      required: true,
      validator(value) {
        return (
          typeof value === 'string' || (value && typeof value === 'object')
        );
      },
    },
    document: {
      required: true,
      validator(value) {
        return (
          value === null ||
          typeof value === 'string' ||
          (value && typeof value === 'object')
        );
      },
    },
    allowNewDocumentsPrimaryKeyEdit: {
      type: Boolean,
      default: true,
    },
  },

  emits: ['input'],

  methods: {
    /**
     * Handle object editor input events - apply to RxDB and emit result
     * @param inputEvent
     */
    async handleInput(inputEvent) {
      if (inputEvent.state === 'updated' && inputEvent.update) {
        try {
          this.doc.$replace(inputEvent.update(this.doc.$data));
          await this.doc.$save();
          this.$emit('input', { state: 'updated' });
        } catch (error) {
          console.error('Failed to update document:', error);
          this.$emit('input', { state: 'error', error });
        }
      }
    },
  },

  template: `
    <object-editor
      class="d-flex flex-column gap-2"
      :schema="doc.$schema"
      :value="doc.$data"
      :allowPrimaryKeyEdit="doc.$isNew && allowNewDocumentsPrimaryKeyEdit"
      v-bind="$attrs"
      @input="handleInput"
    ></object-editor>
  `,
};
